export const SET_BALANCE_NAME = 'SET_BALANCE_NAME';

export function setBalanceName(name) {
  return {
    type: SET_BALANCE_NAME,
    name,
  };
}
